import PropTypes from "prop-types";
import React, {useState} from "react";
import { ButtonLarge } from "../ButtonLarge";
import "./style.css";

export const ContactForm = ({ from, text }) => {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    phone: '',
    otherNotes: ''
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {

    if(formData.name !== '' && formData.email !== '' && formData.message !== '') {
      setStatus('Sending...');

      try {
        const response = await fetch('/contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        const result = await response.json();

        if (result.success) {
          setStatus('Message sent successfully!');
          setFormData({ name: '', email: '', message: '', phone: '', otherNotes: '' });
        } else {
          setStatus('Failed to send message.');
        }
      } catch (error) {
        console.error('Error:', error);
        setStatus('An error occurred.');
      }
    } else {
      setStatus('Please complete the required fields...');
    }
    
  };

  return (
    <div className="form-div">
        <div className="form-box bg-gray">
            <div className="form-div ">
                <div className="fields">
                    <input className="input-2" placeholder="Name*" type="text"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      name="name"
                    />
                    <input className="input-2" placeholder="Email*" type="email" 
                      value={formData.email}
                      onChange={handleChange}
                      required
                      name="email"
                    />
                    <input className="input-2" placeholder="Phone" type="text" 
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      name="phone"
                    />
                    <div className="input-3">
                        <textarea className="text-input" placeholder="I'm looking for*" 
                            onChange={handleChange}
                            name="message"
                            value={formData.message}
                            required
                        >
                        </textarea>
                    </div>
                    <div className="input-3">
                    <textarea className="text-input" placeholder="Other Notes"
                        onChange={handleChange}
                        name="otherNotes"
                        value={formData.otherNotes}
                    >
                    </textarea>
                    </div>
                </div>
                <div className="submitForm">
                  <ButtonLarge className="button-large-black" text="Send request" target="button" callBackFunction={handleSubmit}/>
                  <div className={"roleText" + (status == 'Please complete the required fields...' ? ' error' : '') }>
                      <p>{status}</p>
                  </div>
                </div>
               
            </div>
        </div>
    </div>
  );
};

ContactForm.propTypes = {
  from: PropTypes.oneOf(["jobBoard", "client"]),
};
